import { t } from 'i18next';

export const CategoricalGroupLinkUnionPluginSettings = (): IPluginSettings => {
    let index = 0
    return {
        name: t('directory.categoricalGroup.CategoricalGroupLinkUnionPluginSettings.gridPluginName'),
        mnemocode: "categorical_group_link_union_plugin",
        permission: "CategoricalGroup",
        columns: [
             {
                order: index++,
                propertyName: "idGlobal",
                propertyType: "string",
                displayName: t('directory.categoricalGroup.CategoricalGroupLinkUnionPluginSettings.idGlobal'),
                visibility: false,
                width: 160,
            },
            {
                order: index++,
                propertyName: "categoricalGroupCode",
                propertyType: "string",
                displayName: t('directory.categoricalGroup.CategoricalGroupLinkUnionPluginSettings.categoricalGroupCode'),
                visibility: true,
                width: 160,
            },
            {
                order: index++,
                propertyName: "categoricalGroupName",
                propertyType: "string",
                displayName: t('directory.categoricalGroup.CategoricalGroupLinkUnionPluginSettings.categoricalGroupName'),
                visibility: true,
                width: 360,
            },
            {
                order: index++,
                propertyName: "description",
                propertyType: "string",
                displayName: t('directory.categoricalGroup.CategoricalGroupLinkUnionPluginSettings.description'),
                visibility: true,
                width: 160,
            },
        ],
    }
};
